<!-- 单项选择题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select" :class="topicInfo.showAnalysis ? 'topic_select_none' : ''">
            <div class="topic_type">{{topicInfo.questionTypeName}}</div>
            <div class="topic_content scroll_x mar_left_10 flex-1">
                <div class="topic_title" v-html="topicInfo?.questionTitle" v-mathml></div>
                <div class="flex Flexalign mt-15" v-if="getAudioUrl(topicInfo.otherRule)">
                    <div class="mr-10">音频：</div><audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
                </div>
                <div>
                    <!-- <el-radio-group v-model="topicInfo.doAnswer" @change="changeAnswer">
                        <el-radio v-for="(item, index) in topicInfo.questionContext?.options" :key="index"
                            :value="item.serial" size="large" :disabled="true"> -->
                    <div class="flex Flexalign" v-for="(item, index) in topicInfo.questionContext?.options"
                        :key="index">
                        <div>{{ item.label }} .</div>
                        <div v-html="$Tools.handlerImg(item.content)" v-mathml></div>
                    </div>
                    <!-- </el-radio>
                    </el-radio-group> -->
                </div>
                <div v-if="!topicInfo.showAnalysis">
                    <el-select v-model="selectedValue" placeholder="请选择你的答案顺序" :disabled="topicInfo.showAnalysis"
                        style="min-width: 240px;max-width: 360px;margin-top:30px;" clearable multiple @change="changeAnswer">
                        <template #label="{ label, serial }">
                            <span>{{ label }}: </span>
                            <span style="font-weight: bold">{{ serial }}</span>
                        </template>
                        <el-option v-for="(item, index) in topicInfo.questionContext?.options" :key="index"
                            :label="item.label" :value="item.label" />
                    </el-select>
                </div>
            </div>
        </div>
        <div class="bottom_box flex flexcolumn Flexalign mt-20" v-if="!topicInfo.showAnalysis">
            <div class="btn_view cursor_pointer" @click.stop="submit">提交</div>
            <div class="view_analysis cursor_pointer" @click.stop="viewAnalysis">查看解析</div>
        </div>
        <div class="topic_answer mt-20" v-if="topicInfo.showAnalysis">
            <div class="answer_top flex FlexBetween">
                <div class="flex">
                    <div>参考答案：<span class="correct_value_answer">{{
                        topicInfo.questionContext?.answer
                            }}</span>
                    </div>
                    <div class="mar_left_20">
                        你的答案为：<span class="error_value_answer" :class="topicInfo.questionContext?.answer == topicInfo.doAnswer
                            ? 'correct_value_answer'
                            : ''
                            ">{{
                                topicInfo.doAnswer }}</span>
                    </div>
                </div>
                <!-- <div class="btn_ask">提问</div> -->
            </div>
            <div class="question_analyze mar_top_10">【试题分析】</div>
            <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-mathml></div>
            <div class="question_analyze mar_top_10">【解析】</div>
            <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)" v-mathml></div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "GjkcH5Sort",
    props: {
        questionInfo: {},
        videoQuestionInfo: {}
    },
    computed: {
        ...mapState({
            testExamTime: (state) => state.exam.testExamTime,
        }),
    },

    data() {
        return {
            topicInfo: {},
            selectedValue: [],
        };
    },
    watch: {
        questionInfo: {
            handler(val) {
                if (val) {
                    this.topicInfo = this.questionInfo;
                    // 判断是否回答过
                    if (this.topicInfo.courseExamRecordId) {
                        this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
                    }
                    this.selectedValue = [];
                    // this.selectedValue = this.topicInfo.questionContext.doAnswer.split(",")
                    if (!this.$Tools.empty(this.topicInfo.questionContext.doAnswer)) {
                        this.selectedValue = this.topicInfo.questionContext.doAnswer.split('');
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    },

    mounted() { },

    methods: {
        getAudioUrl(info){
            let ruleInfo = this.$Tools.jsonDecode(info);
            if(!this.$Tools.empty(ruleInfo)){
                return ruleInfo.listeningRule?.audioUrl
            }
        },
        getChoiceLabel(value, options) {
            let label = "";
            options.forEach((item) => {
                if (item.serial == value) {
                    label = item.label;
                }
            });
            return label;
        },
        changeAnswer(value) {
            this.topicInfo.doAnswer = value.map(String).join('');
            if (this.topicInfo.doAnswer == this.topicInfo.questionContext?.answer) {
                this.topicInfo.isCorrect = 1;
            } else {
                this.topicInfo.isCorrect = 2;
            }
            this.topicInfo.questionScore =
                this.topicInfo.isCorrect == 1 ? this.topicInfo.questionContext.score : 0; // 得分
            this.topicInfo.questionContext.doAnswer = this.topicInfo.doAnswer; // 保存答案
            this.topicInfo.questionContext.isFinish = true; // 是否已完成
            //   this.$emit("answerQuestion", this.topicInfo);
        },
        // 提交
        submit() {
            this.topicInfo.answerTimeSection = this.$Tools.jsonEncode(this.topicInfo.answerTimeSection);
            let params = {
                // videoQuestionId: this.topicInfo.videoQuestionId,
                // questionId: this.topicInfo.questionId,
                // chapterId: this.topicInfo.chapterId,
                // questionScore: '',
                // startTime: this.topicInfo.startTime,
                // endTime: this.$Moment().format('YYYY-MM-DD HH:mm:ss'),
                // isCorrect: '',
                // recordContext: this.topicInfo.doAnswer
                paperId: this.videoQuestionInfo.paperId,
                examId: this.videoQuestionInfo.examId,
                examScene: 5,
                isSubmit: 1,
                questions: [this.topicInfo]
            }
            this.$Api.exam.submitVideoQuestion(params).then(res => {
                console.log(res);
                this.$Dialog.toast("提交成功");
                this.viewAnalysis();
            }).catch(() => { })
        },
        viewAnalysis() {
            this.topicInfo.showAnalysis = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    min-height: 360px;

    .topic_type {
        // margin-top: 1rem;
        min-width: 45px;
        padding: 0 8px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {
        // overflow-x: auto;

        .topic_title {
            font-size: 16px;
            color: #242324;
            font-weight: 600;
        }
    }
}

.topic_select_none {
    min-height: auto;
}

.bottom_box {
    // position: absolute;
    // left: calc(50% - 60px);
    // bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
        margin: 0 auto;
    }

    .view_analysis {
        color: #13d6aa;
    }
}

.topic_answer {
    width: 100%;
    // height: 222px;
    background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .answer_top {
        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}
</style>